import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './store';
import App from './App';
import './i18n';
import './index.css';
import { startAutoUpdateWatcher } from './utils/autoUpdate';

window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  window.__bmcl_pwa_prompt = e;
});

startAutoUpdateWatcher();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
